import React, { Component } from "react";

import "../assets/scss/style.scss"; // TODO: xx
import { Lines } from "react-preloaders";
import Home from "./Home";
import LandingPage from "./LandingPage";
import RoofHome from "./RoofHome";
import Foundation from "./Foundation";
import Err404 from "./Err404";
// import Insurance from './Insurance';
// // import Insurance2 from './Insurance2';
// import CampingList from './CampingList';
// import CampingView from './CampingView';
// import PageListView from './PageListView';
// import BlogList from './BlogList';
// import ListPage from './ListPage';
// import ArticleView from './ArticleView';
// import Faq from './Faq';

import Privacy from "./Privacy";
import Cookies from "./Cookies";

import Header from "./Header";
import Footer from "./Footer";
// import Contact from './Contact';

import CookieConsent from "react-cookie-consent";

import { Link, Route, Redirect, Switch } from "react-router-dom";
import ScrollToTop from "react-router-scroll-top";

import { Helmet } from "react-helmet";

import store from "../store/index";
// import { addLastUrl } from "../actions/index";
import "./App.css";
import NewHome from "./NewHome";
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      loading: true,
      hidePreloader: false
    };

    window.redirectTo = this.redirectTo.bind(this);
  }

  redirectTo(url) {
    // store.dispatch(addLastUrl(window.location.pathname));
    // store.dispatch(addLastUrl(window.location.pathname));

    this.setState({
      redirect: url
    });
  }
/*   moveWindow() {
    window.addEventListener("load", () => {
      let startOffsetTop = document.getElementById("main").offsetTop;
      setTimeout(() => {
        window.scrollTo(0, startOffsetTop);
        this.setState({ hidePreloader: true });
      }, 1);
      console.log("window.addEventListener", startOffsetTop);
    });
  } */

  componentDidMount() {
    /*     let startOffsetTop = document.getElementById("main").getBoundingClientRect().top;
    let startHeight = document.getElementById("main").clientHeight; */
    //this.moveWindow();
    // setTimeout(() => {}, 1);
    // setTimeout(() => {this.setState({ hidePreloader: true });}, 1);
  }

  getHelmetMeta() {
    if (typeof window.preloadedInitialState.meta != "undefined") {
      let thisMeta = window.preloadedInitialState.meta.filter(
        m => m.url == window.location.pathname
      );
      if (thisMeta.length) {
        thisMeta = thisMeta[0];

        return (
          <Helmet>
            <title>{thisMeta.pageTitle}</title>
            <meta name="description" content={thisMeta.metaDescription} />
            <meta name="keywords" content={thisMeta.keywords} />
          </Helmet>
        );
      }
    }

    return (
      <Helmet>
        <title>Evomer</title>
        <meta name="description" content="Evomer - dwa razy szybciej niż inne rozwiązania" />
        <meta name="keywords" content="Evomer, renowacja dachu, hydroizoalcja fundamentu" />
      </Helmet>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div>
          {this.getHelmetMeta()}

          {this.state.redirect
            ? (() => {
                let goToUrl = this.state.redirect;

                this.state.redirect = false;

                return <Redirect to={goToUrl} />;
              })()
            : ""}
          <Switch>
            <Route
              exact
              path="/"
              component={() => <NewHome redirectTo={this.redirectTo.bind(this)} />}
            />
             <Route
              path="/dach"
              component={RoofHome}
            />
            <Route
              path="/fundamenty"
              component={Foundation}
            />
            <Redirect from="/kontakt" to="/#kontakt" />
            <Route path="/polityka-prywatnosci" component={Privacy} />
            <Route path="/cookies" component={Cookies} />
            <Route
              component={() => (
                <Err404 redirectTo={this.redirectTo.bind(this)} />
              )}
            />
          </Switch>

          <CookieConsent
            location="bottom"
            buttonText="Akceptuję politykę cookies"
            cookieName="cookie01"
            style={{ background: "#22272a" }}
            expires={150}
          >
            Ta strona korzysta z plików cookies. Sprawdź{" "}
            <Link to={"/cookies/"}>politykę plików cookies</Link>.
          </CookieConsent>

          <ScrollToTop />
        </div>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js